var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_4326_8013)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9008 23H13.0609L20 6H17.3238L12.0096 19.7811L6.75269 6.04024L6.73357 6H4L10.8817 22.9598L10.9008 23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6922 15.9188C23.6824 15.9121 23.6824 15.9121 23.6726 15.9055C23.5716 15.8224 23.4538 15.7851 23.3355 15.7905L22.4191 15.8112L21.1195 14.0384L20.393 14.1168L21.0257 15.9225L20.0106 15.9619L19.5398 15.4122L19.004 15.4628L19.437 16.531L19.0914 17.6277L19.6303 17.5935L20.0563 17.0098L21.0549 16.9736L20.5311 18.837L21.2674 18.7653L22.4514 16.8788L23.3678 16.8581C23.6537 16.8379 23.8794 16.5905 23.869 16.3113C23.8542 16.1437 23.7932 16.0019 23.6922 15.9188Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16L10 16.5L17.5 17V16Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4326_8013",
    x1: 28,
    y1: 14,
    x2: 0,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#431280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD0000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa);
export default __webpack_public_path__ + "static/media/VA.225a53601629eacac2a1de800023badf.svg";
export { ForwardRef as ReactComponent };